const DEBUG = String(process.env.NEXT_PUBLIC_DEBUG_AUTH || '').toLowerCase() === 'true'
const clog = (...args) => { if (DEBUG) try { console.log('[AUTH][CLIENT]', ...args) } catch {} }

export async function loginEmail(email, password) {
  clog('login start')
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password })
  })
  clog('login response', res.status)
  if (!res.ok) {
    let err = {}
    try { err = await res.json() } catch {}
    clog('login error', err)
    throw new Error(err?.message || `Login failed (${res.status})`)
  }
  return res.json()
}

export async function getAccount() {
  clog('account start')
  const res = await fetch('/api/auth/account', {
    method: 'GET',
    credentials: 'include',
    cache: 'no-store'
  })
  clog('account response', res.status)
  if (!res.ok) return null
  return res.json()
}

export async function logoutCurrent() {
  clog('logout start')
  const res = await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
  clog('logout response', res.status)
  if (!res.ok) {
    let err = {}
    try { err = await res.json() } catch {}
    clog('logout error', err)
    throw new Error(err?.message || `Logout failed (${res.status})`)
  }
  return { ok: true }
}

export async function signUpEmail(email, password, name) {
  clog('signup start')
  const res = await fetch('/api/auth/signup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ email, password, name })
  })
  clog('signup response', res.status)
  if (!res.ok) {
    let err = {}
    try { err = await res.json() } catch {}
    clog('signup error', err)
    throw new Error(err?.message || `Sign up failed (${res.status})`)
  }
  return res.json()
}
